<template>
  <div
    class="m-dropdown-content m-dropdown-content-left"
    id="MoleculeEditionBillingAcademyChargesDropDownFilters"
  >
    <section
      v-if="showLoadingState < 3"
      key="loadingState"
      class="m-dropdown-section"
    >
    <ul class="m-dropdown-list">
      <li>
        <a
          href="#"
          @click.prevent=""
        >
          <AtomLoadingSecondary/>
        </a>
      </li>
    </ul>
    </section>
    <form
      v-else
      key="billingAcademyChargesDropDownFilters"
      autocomplete="off"
      name="AcademyChargesDropDownFilters"
      spellcheck="false"
      @submit.prevent="searchAdvancedFilter"
    >
      <section class="m-dropdown-section">
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingAcademyChargesDropDownFilters.input.type_product.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <AtomSelectPrimary
                v-model.number="filter.tipo_producto"
                :elements="$filters.parameters.typesOfProduct"
                keyField="id"
                name="typeProduct"
                reference="typeProduct"
                textField="name"
              />
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingAcademyChargesDropDownFilters.input.pais.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <AtomSelectPrimary
                v-model="filter.pais"
                :elements="paisesSelect"
                key-field="id_pais"
                name="pais"
                reference="pais"
                text-field="nombre"
              />
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingAcademyChargesDropDownFilters.input.medioPago.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <ul>
                <li
                  v-for="(pasarela, index) in pasarelasPago"
                  :key="index"
                >
                  <AtomCheckboxPrimary
                    v-model="filter.pasarela_pago"
                    inputStyle="billing"
                    name="medio"
                    :text="pasarela.nombre"
                    :value="pasarela.id"
                    wrapper-class="margin-zero"
                  />
                </li>
              </ul>
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
             {{ $t('mEditionBillingAcademyChargesDropDownFilters.input.email.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <input
                v-model="filter.buscar"
                class="a-input-primary"
                name="email"
                :placeholder="$t('mEditionBillingAcademyChargesDropDownFilters.input.email.placeholder')"
                type="text"
              />
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingAcademyChargesDropDownFilters.input.fechaDesde.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <AtomDatePicker
                v-model="filter.fecha_desde"
                label=""
                name="fecha_desde"
                :placeholder="$t('mEditionBillingAcademyChargesDropDownFilters.input.fechaDesde.placeholder')"
              />
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingAcademyChargesDropDownFilters.input.fechaHasta.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <AtomDatePicker
                v-model="filter.fecha_hasta"
                :disabled-dates="disabledDates"
                name="fecha_hasta"
                :placeholder="$t('mEditionBillingAcademyChargesDropDownFilters.input.fechaHasta.placeholder')"
              />
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingAcademyChargesDropDownFilters.input.productos.label') }}
            </a>
            <div class="m-dropdown-sublist m-dropdown-sublist-scrollable">
              <ul>
                <li
                  v-for="(producto, index) in productos"
                  :key="index"
                >
                  <AtomCheckboxPrimary
                    v-model="filter.producto"
                    inputStyle="billing"
                    name="productos"
                    :text="producto.nombre"
                    :value="producto.id"
                    wrapper-class="margin-zero"
                  />
                </li>
              </ul>
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingAcademyChargesDropDownFilters.input.descuento.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <input
                v-model="filter.cupon"
                class="a-input-primary"
                name="descuento"
                :placeholder="$t('mEditionBillingAcademyChargesDropDownFilters.input.descuento.placeholder')"
                type="text"
              >
            </div>
          </li>
        </ul>
      </section>
      <footer class="m-dropdown-footer">
        <button
          class="a-button-dropdown-secondary"
          @click="reloadListing"
        >
          {{ $t('mEditionBillingAcademyChargesDropDownFilters.buttonSecondary.restartText') }}
        </button>
        <button
          class="a-button-primary a-button-billing-primary a-button-dropdown-primary"
          type="submit"
        >
          {{ $t('mEditionBillingAcademyChargesDropDownFilters.buttonPrimary') }}
        </button>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingAcademyChargesDropDownFilters',

  props: {
    academiaIdSeted: String,
    academiaUrlSeted: String,
    filterSeted: Object
  },

  data () {
    return {
      academia_url: '',

      disabledDates: {
        to: ''
      },

      filter: {
        buscar: '',
        cupon: '',
        divisa: [],
        estado: [],
        fecha_desde: '',
        fecha_hasta: '',
        limite: 10,
        pagina: 1,
        pais: '',
        pasarela_pago: [],
        producto: [],
        tipo_producto: ''
      },

      pasarelasPago: [],
      paises: [],
      productos: [],
      showLoadingState: 0
    }
  },

  computed: {
    paisesSelect () {
      let paises = [...this.paises]
      paises.unshift({
        id_pais: '',
        nombre: this.$t('mEditionBillingAcademyChargesDropDownFilters.input.pais.firstOption')
      })
      return paises
    }
  },

  watch: {
    'filter.fecha_desde' () {
      if (this.$moment(this.filter.fecha_desde).isAfter(this.filter.fecha_hasta)) {
        this.filter.fecha_hasta = null
      }

      this.disabledDates = {
        to: this.filter.fecha_desde
      }
    },

    academiaIdSeted: {
      deep: true,

      handler () {
        if (this.academiaIdSeted) {
          this.readProductos()
        }
      },

      immediate: true
    },

    academiaUrlSeted: {
      deep: true,

      handler () {
        this.academia_url = this.academiaUrlSeted
      },

      immediate: true
    },

    filterSeted: {
      deep: true,

      handler () {
        this.filter.buscar = this.filterSeted.buscar
        this.filter.cupon = this.filterSeted.cupon
        this.filter.divisa = [...this.filterSeted.divisa]
        this.filter.estado = [...this.filterSeted.estado]
        this.filter.fecha_desde = this.filterSeted.fecha_desde
        this.filter.fecha_hasta = this.filterSeted.fecha_hasta
        this.filter.pais = this.filterSeted.pais
        this.filter.pasarela_pago = [...this.filterSeted.pasarela_pago]
        this.filter.producto = [...this.filterSeted.producto]
        this.filter.tipo_producto = this.filterSeted.tipo_producto

        this.disabledDates = {
          to: this.filter.fecha_desde
        }
      },

      immediate: true
    }
  },

  created () {
    this.academia_url = this.academiaUrlSeted
    this.readPasarelasPagoActivas()
    this.readParametroPaises()
  },

  methods: {
    readParametroPaises () {
      this.$services.read('parametro', 'readParametroPaises')
        .then(response => {
          this.paises = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readPasarelasPagoActivas () {
      this.$services.read('pasarela', 'readPasarelas')
        .then(response => {
          this.pasarelasPago = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readProductos () {
      this.$services.read('producto', 'readProductos', {}, [this.academiaIdSeted], { limite: 1000 })
        .then(response => {
          this.productos = response.data.productos
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    reloadListing () {
      this.$emit('reloadListing')
    },

    searchAdvancedFilter () {
      this.$dropDown.switchDropDown('MoleculeEditionBillingAcademyChargesDropDownFilters')
      this.$emit('searchAdvancedFilter', this.filter, this.academia_url)
    }
  }
}
</script>
